<template>
  <div>
    <mcs-info-card class="pa-4 mb-5">
      <div
        v-if="certificate.expired"
        class="body-2"
      >
        This certificate has epxired. Please replace this certificate with a current one.
      </div>
      <div
        v-else
        class="body-2"
      >
        <div>
          <v-icon :color="certificate.color"> mdi-circle-medium </v-icon>
          <span class="font-weight-bold">{{ certificate.status }}</span>
        </div>
        <div class="ml-2">
          {{ statusMessage }}
        </div>
      </div>
    </mcs-info-card>

    <CertificateUploadButton
      buttonText="Replace Certificate"
      :certificateId="certificate.id"
      :userId="userId"
      @deleted="$emit('home')"
    />

    <v-text-field
      v-model="edit_certificate.name"
      outlined
      label="Cerficiate Name"
      placeholder="Certificate Name"
      persistent-placeholder
      maxlength="100"
      hide-details="auto"
      class="white mt-5"
    />

    <v-textarea
      v-model="edit_certificate.userNote"
      label="Please describe why you are exempt from sales tax"
      persistent-placeholder
      outlined
      class="body-2 mt-5"
      maxlength="500"
      hide-details="auto"
    />

    <Portal :to="`drawerAppend-${drawerId}`">
      <v-divider />
      <v-row class="pa-2 ma-0">
        <v-col cols="12">
          <mcs-btn
            :loading="saving"
            large
            block
            color="black"
            @click="save"
          >
            Save
          </mcs-btn>
        </v-col>
      </v-row>
    </Portal>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { DRAWERS, EXEMPTION_CERTIFICATE_STATUS } from '../../../utils/constants';
import CertificateUploadButton from './CertificateUploadButton';

export default {
  name: 'CertificateDetailsView',

  components: {
    CertificateUploadButton
  },

  props: {
    id: {
      type: Number,
      default: 0
    },
    userId: { type: Number, default: 0 }
  },

  data() {
    return {
      drawerId: DRAWERS.EXEMPTION_CERTIFICATES_DRAWER,
      certificate: {},
      edit_certificate: {},
      saving: false
    };
  },

  computed: {
    statusMessage() {
      var msg = '';
      if (this.certificate.statusId === EXEMPTION_CERTIFICATE_STATUS.APPROVED) {
        msg =
          'This tax exemption certificate has been reviewed and aproved. You are exempt from paying sales tax on your orders';
      } else if (this.certificate.statusId === EXEMPTION_CERTIFICATE_STATUS.UNDER_REVIEW) {
        msg =
          'This tax exemption is under review. You’re exempt from paying sales tax and can order unless we find any issues.';
      } else {
        msg = this.certificate.rejectionNote;
      }
      return msg;
    }
  },

  mounted() {
    this.certificate = this.$store.getters[
      this.userId ? 'admin/users/taxExemptCertificates' : 'user/taxExemptCertificates'
    ].find((x) => x.id === this.id);
    this.edit_certificate = cloneDeep(this.certificate);
  },

  methods: {
    async save() {
      this.saving = true;
      /* eslint-disable indent */
      await (this.userId
        ? this.$store.dispatch('admin/users/updateExemptionCertificate', {
            userId: this.userId,
            payload: this.edit_certificate
          })
        : this.$store.dispatch('user/updateExemptionCertificate', this.edit_certificate)
      ).finally(() => {
        this.saving = false;
      });
      /* eslint-disable indent */
    }
  }
};
</script>

<style scoped></style>
